/**
 * The match clock moved to `src/app/matchClock.ts`: the gameweek grid renders the
 * same ticking minute on its live cards, and a component importing out of `app/backoffice/` to get
 * it reads wrong. The backoffice keeps this import path.
 */
export {
  FIRST_HALF_CEILING,
  SECOND_HALF_CEILING,
  countdown,
  displayMinute,
  useMatchClock,
  type TickingClock,
} from '../matchClock'
